












































































import { Component } from 'vue-mixin-decorator';
import { Watch } from 'vue-property-decorator';
import BaseView from '@/views/BaseView.vue';
import ExamHeader from '@/components/ExamHeader.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';

import * as DesignCode from '@/classification/DesignCode';

import MarkdownToHTML from '@/common/MarkdownToHTML';
import * as JwtUtil from '@/common/JwtUtil';
import * as StringUtil from '@/common/StringUtil';

import RepositoryFactory from '@/repository/RepositoryFactory';

import DesignResource from '@/models/exam/DesignResource';
import Goods from '@/models/goods/Goods';
import GoodsDetailDto from '@/models/goods/GoodsDetail';

@Component(
  {
    components: {
      'e-header': ExamHeader,
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-indicator': IndicatorModal,
    },
  },
)
export default class GoodsDetail extends BaseView {
  private ExamRepository = RepositoryFactory.get().exam;

  private GoodsRepository = RepositoryFactory.get().goods;

  private goods = new GoodsDetailDto();

  private examTitle = '';

  private otherGoods: Goods[] = [];

  private resources = {
    EXAM_RANK_ICON: new DesignResource(),
  };

  private isIndicatorDisplay = false;

  private canPurchase = false;

  private showFee = false;

  private created() {
    // パラメータチェック
    if (!this.$route.query.goods_code) {
      this.$router.replace(this.paths.TOP);
    }
  }

  private mounted() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const ExamDetailCss = document.createElement('link');
    ExamDetailCss.rel = 'stylesheet';
    ExamDetailCss.href = '/kentei/css/detail.css';
    this.$el.appendChild(ExamDetailCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);

    this.init();
  }

  @Watch('$route', { immediate: true, deep: true })
  private onUrlChange(to: any, from: any) {
    // 変更情報が存在しない場合は何もしない
    if (!to || !from) return;

    // rankパラメータが存在しない場合何もしない（createdでTOPに戻す）
    if (StringUtil.isEmpty(to.query.goods_code) || StringUtil.isEmpty(from.query.goods_code)) {
      return;
    }

    if (to.query.goods_code !== from.query.goods_code) {
      // インスタンスの再生成が行えないためデータ取得処理を再呼び出し
      this.init();
    }
  }

  /**
   * 初期データセット
   */
  private async init() {
    this.isIndicatorDisplay = true;
    await this.getExam();
    await this.getGoods();
    await this.getGoodsList();
    this.isIndicatorDisplay = false;
  }

  /**
   * 検定情報取得
   */
  private async getExam() {
    try {
      await this.ExamRepository.getExam().then((response) => {
        this.examTitle = response.data.exam_title;

        // デザインリソース
        if (response.data.resources !== undefined) {
          response.data.resources.forEach((resource: any) => {
            const key = resource.display_place_key;
            if (key in this.resources) {
              const tmp = new DesignResource();
              tmp.displayPlaceKey = resource.display_place_key;
              tmp.displayText = StringUtil.isEmpty(resource.display_text) ? '' : resource.display_text;
              tmp.cssClassName = StringUtil.isEmpty(resource.css_class_name) ? '' : resource.css_class_name;
              tmp.resourceUri = StringUtil.isEmpty(resource.resource_uri) ? '' : resource.resource_uri;
              tmp.resourceFileName = StringUtil.isEmpty(resource.resource_file_name) ? '' : resource.resource_file_name;
              tmp.alternativeText = StringUtil.isEmpty(resource.alternative_text) ? '' : resource.alternative_text;
              // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
              // @ts-ignore
              this.resources[key] = tmp;
            }
          });
        }
      }).catch(() => {
        this.$router.replace(this.paths.TOP);
      });
    } catch (_) {
      this.$router.replace(this.paths.TOP);
    }
  }

  /**
   * グッズ情報取得
   */
  private async getGoods() {
    const goodsCode = String(this.$route.query.goods_code);
    await this.GoodsRepository.getGoods(goodsCode).then((response: any) => {
      if (response.status === 200) {
        this.goods.goodsCodeOrg = response.data.goods_code;
        this.goods.goodsCode = StringUtil.encodeToBase64Url(response.data.goods_code);
        this.goods.goodsTitle = response.data.goods_title;
        this.goods.overview = MarkdownToHTML(response.data.overview);
        this.goods.canEntry = response.data.can_entry;

        if (response.data.fees.length > 0) {
          this.goods.fee = StringUtil.separateNumber(response.data.fees[0].fee);
        }

        // eslint-disable-next-line prefer-destructuring
        const resources = response.data.resources;
        if (resources !== undefined && resources.length > 0) {
          resources.forEach((resource: any) => {
            if (resource.display_place_key === DesignCode.EXAM_RANK_ICON) {
              this.goods.thumbnail = resource.resource_uri;
              this.goods.alternativeText = resource.alternative_text;
            }
          });
        }

        // 料金が設定されている場合ボタン活性化 ただし、ログインしていて資格が無い場合は不可
        this.canPurchase = (response.data.fees.length > 0 && (JwtUtil.getJwtInfo() === null || (JwtUtil.getJwtInfo() !== null && this.goods.canEntry)));
        // 料金が設定されている場合のみ料金表示
        this.showFee = response.data.fees.length > 0;
      } else {
        this.$router.replace(this.paths.TOP);
      }
    }).catch(() => {
      this.$router.replace(this.paths.TOP);
    });
  }

  /**
   * グッズ一覧取得
   */
  private async getGoodsList() {
    // 画面再描画時、直前のデータが残ってしまうため初期化
    this.otherGoods = [];

    await this.GoodsRepository.getGoodsList().then((response: any) => {
      if (response.status === 200) {
        response.data.goods_list.forEach((goods: any) => {
          const goodsObj = new Goods();
          goodsObj.goodsCode = StringUtil.encodeToBase64Url(goods.goods_code);
          goodsObj.goodsTitle = goods.goods_title;
          if (goods.fees.length > 0) {
            goodsObj.fee = StringUtil.separateNumber(goods.fees[0].fee);
          } else {
            goodsObj.fee = '0';
          }

          // eslint-disable-next-line prefer-destructuring
          const resources = goods.resources;
          if (resources !== undefined && resources.length > 0) {
            resources.forEach((resource: any) => {
              if (resource.display_place_key === DesignCode.EXAM_RANK_ICON) {
                goodsObj.thumbnail = resource.resource_uri;
                goodsObj.alternativeText = resource.alternative_text;
              }
            });
          }

          // 詳細表示中のグッズは除外
          if (this.goods.goodsCodeOrg !== goods.goods_code) {
            this.otherGoods.push(goodsObj);
          }
        });
      } else {
        this.$router.replace(this.paths.TOP);
      }
    }).catch(() => {
      this.$router.replace(this.paths.TOP);
    });
  }

  /**
   * 申し込み(購入)画面へ遷移
   */
  private async transitionToEntry() {
    // 購入条件を満たしていない場合は購入ボタンを押せないが念のため再チェック
    const jwt = JwtUtil.getJwtInfo();
    if (jwt == null) {
      // 未ログインの場合、ログイン/仮登録画面へ
      sessionStorage.setItem(JwtUtil.SESSION_RETURN_PATH_KEY, `${this.paths.ACCOUNT_CONFIRM}?goods_code=${this.goods.goodsCode}`);
      // eslint-disable-next-line @typescript-eslint/camelcase
      this.$router.replace({ path: this.paths.LOGIN });
    } else if (!this.goods.canEntry) {
      // 購入不可 不正操作のためTOPへ
      this.$router.replace(this.paths.TOP);
    } else {
      // 内容確認画面へ
      // eslint-disable-next-line @typescript-eslint/camelcase
      this.$router.replace({ path: this.paths.ACCOUNT_CONFIRM, query: { goods_code: this.goods.goodsCode } });
    }
  }
}
